import axios from "axios";

export default {
    state: {
        icdChapters: []
    },
    getters: {
        icdChapters: state => {
            return state.icdChapters;
        }
    },
    mutations: {
        SET_ICD_CHAPTERS(state, icdChapters) {
            state.icdChapters = icdChapters;
        }
    },
    actions: {
        GET_ICD_CHAPTERS: ({ commit, getters }) => {
            if(getters.icdChapters.length == 0) {
                axios.get("/icd/chapters")
                    .then(response => {
                        console.log(response.data);
                        commit('SET_ICD_CHAPTERS', response.data.icd_chapters);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
    }
}